import { useLocation } from 'react-router';
import { NAV_ITEMS } from '../app/nav';
import './page.css';

/** A section that is not in the new panel yet. */
export function NotMoved() {
  const { pathname } = useLocation();
  const item = NAV_ITEMS.find((i) => i.to !== '/' && pathname.startsWith(i.to));
  return (
    <div className="page">
      <div className="page-h">
        <h1>{item?.label ?? 'Not found'}</h1>
        <p className="sub">{item ? 'This section is not in the new panel yet.' : 'There is no page at this address.'}</p>
      </div>
    </div>
  );
}
